"use client";
import { jsx as i } from "react/jsx-runtime";
import * as o from "@radix-ui/react-separator";
import * as p from "react";
import { cn as l } from "./index15.js";
const s = p.forwardRef(({ className: a, orientation: r = "horizontal", decorative: t = !0, ...e }, m) => /* @__PURE__ */ i(
  o.Root,
  {
    ref: m,
    decorative: t,
    orientation: r,
    className: l(
      "shrink-0 bg-border",
      r === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      a
    ),
    ...e
  }
));
s.displayName = o.Root.displayName;
export {
  s as Separator
};
//# sourceMappingURL=index12.js.map
